import Joi from 'joi';

/**
 * Schema for validating check-in record properties.
 * @description This schema ensures that the actual odometer value is correctly entered as a number
 * and that the check-in date is valid and not set in the future.
 * Additional properties beyond those defined in the schema are ignored.
 */
export const checkInSchema = () =>
	Joi.object({
		actualOdometerValue: Joi.number().allow(null).messages({
			'number.base':
				'validations|check-in|actual-odometer-value-must-be-number',
		}),
		actualCheckInAt: Joi.date().max('now').required().messages({
			'date.base': 'validations|check-in|actual-check-in-at-date-must-be-valid',
			'date.max':
				'validations|check-in|actual-check-in-at-date-cannot-be-in-future',
			'any.required': 'validations|check-in|actual-check-in-at-date-required',
		}),
	})
		// Allows additional properties to be included in the object without causing validation errors
		.unknown(true);
